module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMABAgYGxxvs8fP83Urbd0AAABbSURBVCjPY2BQ69oNByuSGBiYZ+9GAjsNGDR3o4CJDNmoAtsYulEFdjCsRhXYxbAbDQygQGk4AoMFDFgRGLtAiTsC7x40fsEIZIxowIgojKjEiGwGMeTkkMgAAIX/X4ajyIC5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yhl-w.png
// module id = qOgP
// module chunks = 1